
import { msg, str } from '@lit/localize';
import { getUrlFromFileId } from '../utilities/formsUtilities';

const locationTypes = [
    {name: 'Circus', label: msg('Circus')},
    {name: 'CombinedArts', label: msg('Combined Arts')},
    {name: 'Comedy', label: msg('Comedy')},
    {name: 'CommunitySpace', label: msg('Community Space')},
    {name: 'Craft', label: msg('Craft')},
    {name: 'Dance', label: msg('Dance')},
    {name: 'Festival', label: msg('Festival')},
    {name: 'Educational', label: msg('Educational')},
    {name: 'FamilyFriendly', label: msg('Family Friendly')},
    {name: 'FilmCinema', label: msg('Film/Cinema')},
    {name: 'Gallery', label: msg('Gallery')},
    {name: 'ImmersiveAndVR', label: msg('Immersive and VR')},
    {name: 'Library', label: msg('Library')},
    {name: 'LiteraturePoetry', label: msg('Literature and Poetry')},
    {name: 'Museum', label: msg('Museum')},
    {name: 'Music', label: msg('Music')},
    {name: 'Theatre', label: msg('Theatre')},
    {name: 'VisitorAttraction', label: msg('Visitor Attraction')},
    {name: 'VisualArt', label: msg('Visual Art')}
];

const languages = [
    {name: 'en', label: 'English'},
    {name: 'cy', label: 'Cymraeg'},
   // {name: 'ga', label: 'Gaeilge'},
    {name: 'gd', label: 'Gaelic'}
];


const processLocationData = (_locationData)=> {  
    let locData,draftLocData,provisionData;
    let locationData = _locationData.location_data;
    if(!locationData){
        return false;
    }
    locData = [
            {name:'photo1',type:'file',title:msg('Location'),value:locationData.photo1,required: true},
            {name:'photo2',type:'file',title:msg('Location'),value:locationData.photo2},
            {name:'photo3',type:'file',title:msg('Location'),value:locationData.photo3},
            {name:'name',type:'text',title:msg(str`Name`),value:_locationData.name,'required':true},
            {name:'language',type:'select',title:msg('Language'),value:locationData.language,options:languages},
            {name:'address1',type:'text',title:msg(str`Street address`),value:locationData.address1,'required':true},
            {name:'address2',type:'text',title:msg(str`Address Line 2`),value:locationData.address2},
            {name:'city',type:'text',title:msg(str`City`),value:locationData.city,'required':true},
            {name:'country',type:'text',title:msg(str`Country`),value:locationData.country,'required':true},
            {name:'postcode',type:'text',title:msg(str`Postcode`),value:locationData.postcode,'required':true},
            {name:'phone',type:'text',title:msg(str`Phone`),value:locationData.phone},
            {name:'email',type:'email',title:msg(str`Email`),value:locationData.email},
            {name:'website',type:'url',title:msg(str`Website`),value:locationData.website,'required':true},
            {name:'description',type:'textarea',title:msg(str`Description`),value:locationData.description,'required':true},
            {name:'type',type:'multiselect',title:msg(str`What artforms does this location offer?`),value:locationData.type,'required':true,options:locationTypes},
            {name:'accessInformation',type:'url',title:msg(str`Access information URL`),value:locationData.accessInformation},
            {name:'videoUrl',type:'url',title:msg(str`Familiarisation tour URL`),value: locationData.videoUrl},
            {name:'videoDescription',type:'text',title:msg(str`Familiarisation tour description`),value: locationData.videoDescription,requiredIf:'videoUrl'},
            {name:'visualStory',type:'url',title:msg(str`Visual Story URL`),value: locationData.visualStory},
            {name:'accessAble',type:'url',title:msg(str`AccessAble URL`),value: locationData.accessAble},
            {name:'euansGuide',type:'url',title:msg(str`Euan's Guide URL`),value: locationData.euansGuide},
            {name:'acceptCeaCard',type:'checkbox',title:msg(str`Accept CEA Card`),value:locationData.acceptCeaCard}, 
            {name:'acceptNimbusCard',type:'checkbox',title:msg(str`Accept Access Card`),value:locationData.acceptNimbusCard},
            {name:'acceptSunflowerLanyard',type:'checkbox',title:msg(str`Accept Sunflower Lanyards`),value:locationData.acceptSunflowerLanyard},
            {name:'allInScheme',type:'checkbox',title:msg(str`Part of All In`),value:locationData.allInScheme},
            {name:'requiresProofOfEligibility',type:'checkbox',title:msg(str`Require proof of eligibility`),value:locationData.requiresProofOfEligibility}, 
            
        ];
    provisionData = {};
    if(locationData.hasOwnProperty('draftInfo') && locationData.draftInfo && locationData.approvalStatus=='AwaitingResponse'){
        if(typeof locationData.draftInfo === 'string'){
            locationData.draftInfo = JSON.parse(locationData.draftInfo);
        }
        let photo1 = {};
        if(locationData.draftInfo.photo1PublicUrl){
            photo1 = {publicUrl:locationData.draftInfo.photo1PublicUrl};
        }
        else if(locationData.photo1 && locationData.photo1.id){
            photo1 = locationData.photo1
        }
        if(locationData.draftInfo.photo1AltText){
            photo1.altText = locationData.draftInfo.photo1AltText;
        }
        let photo2 = {};
        if(locationData.draftInfo.photo2PublicUrl){
            photo2 =  {publicUrl:locationData.draftInfo.photo2PublicUrl};
        }
        else if(locationData.photo2 && locationData.photo2.id){
            photo2 = locationData.photo2
        }
        if(locationData.draftInfo.photo2AltText){
            photo2.altText = locationData.draftInfo.photo2AltText;
        }
        let photo3 = {};
        if(locationData.draftInfo.photo3PublicUrl){
            photo3 =  {publicUrl:locationData.draftInfo.photo3PublicUrl};
        }
        else if(locationData.photo3 && locationData.photo3.id){
            photo3 = locationData.photo3
        }
        if(locationData.draftInfo.photo3AltText){
            photo3.altText = locationData.draftInfo.photo3AltText;
        }
        draftLocData = [
            {name:'photo1',type:'file',title:msg('Location'),value:photo1,required: true},
            {name:'photo2',type:'file',title:msg('Location'),value:photo2}, 
            {name:'photo3',type:'file',title:msg('Location'),value:photo3},
            {name:'name',type:'text',title:msg(str`Name`),value:locationData.draftInfo.name,'required':true},
            {name:'language',type:'select',title:msg('Language'),value:locationData.draftInfo.language,options:languages},
            {name:'address1',type:'text',title:msg(str`Street Address`),value:locationData.draftInfo.address1,'required':true},
            {name:'address2',type:'text',title:msg(str`Address Line 2`),value:locationData.draftInfo.address2},
            {name:'city',type:'text',title:msg(str`City`),value:locationData.draftInfo.city,'required':true},
            {name:'country',type:'text',title:msg(str`Country`),value:locationData.draftInfo.country,'required':true},
            {name:'postcode',type:'text',title:msg(str`Postcode`), value:locationData.draftInfo.postcode,'required':true},
            {name:'phone',type:'text',title:msg(str`Phone`),value:locationData.draftInfo.phone},
            {name:'email',type:'email',title:msg(str`Email`),value:locationData.draftInfo.email},
            {name:'website',type:'url',title:msg(str`Website`),value:locationData.draftInfo.website,'required':true},
            {name:'description',type:'textarea',title:msg(str`Description`),value:locationData.draftInfo.description,'required':true},
            {name:'type',type:'multiselect',title:msg(str`What artforms does this location offer?`),value:locationData.draftInfo.type,'required':true,options:locationTypes},
            {name:'accessInformation',type:'url',title:msg(str`Access information URL`),value:locationData.draftInfo.accessInformation},
            {name:'videoUrl',type:'url',title:msg(str`Familiarisation tour URL`),value: locationData.draftInfo.videoUrl},
            {name:'videoDescription',type:'text',title:msg(str`Familiarisation tour description`),value: locationData.draftInfo.videoDescription,requiredIf:'videoUrl'},
            {name:'visualStory',type:'url',title:msg(str`Visual Story URL`),value: locationData.draftInfo.visualStory},
            {name:'accessAble',type:'url',title:msg(str`AccessAble URL`),value: locationData.draftInfo.accessAble},
            {name:'euansGuide',type:'url',title:msg(str`Euan's Guide URL`),value: locationData.draftInfo.euansGuide},
            {name:'acceptCeaCard',type:'checkbox',title:msg(str`Accpet CEA Card`),value:locationData.draftInfo.acceptCeaCard}, 
            {name:'acceptNimbusCard',type:'checkbox',title:msg(str`Accept Access Card`),value:locationData.draftInfo.acceptNimbusCard},
            {name:'acceptSunflowerLanyard',type:'checkbox',title:msg(str`Accept Sunflower Lanyards`),value:locationData.draftInfo.acceptSunflowerLanyard},
            {name:'allInScheme',type:'checkbox',title:msg(str`Part of All In`),value:locationData.draftInfo.allInScheme},
            {name:'requiresProofOfEligibility',type:'checkbox',title:msg(str`Require proof of eligibility`),value:locationData.draftInfo.requiresProofOfEligibility},
            
        ];
    }
    else{
        draftLocData = [];
    }
    if(_locationData.provisions){

        provisionData = Object.entries(_locationData.provisions);
        provisionData = provisionData?.map((provision)=>{
            provision = provision[1];
            provision.provisions = provision.provisions.map((item)=>{
                if(item.hasOwnProperty('provision_data')){
                    return {
                        name:item.standard?.name,
                        id:item.standard?.id,
                        image:item.provision_data.photo?.publicUrl,
                        imageId:item.provision_data.photo?.id,
                        alt:item.provision_data.photo?.altText,
                        description:item.provision_data?.description,
                        draft:item.provision_data?.draft,
                    }
                }
                else{
                    return {
                        name:item.name,
                        id:item.id,
                        image:item.image,
                        imageId:item.imageId,
                        alt:item.alt,
                        description:item.description,
                        draft:item.draft,
                    }
                }
            })
            return provision;
        }); 
    }
    return {
        locData: locData,
        draftLocData: draftLocData,
        provisionData: provisionData
    };
}

export { processLocationData, locationTypes };